






import { defineComponent } from '@vue/composition-api';

import PanelWithJobEditor from '@/components/Job/PanelWithJobEditor.vue';

const Create = defineComponent({
  components: {
    PanelWithJobEditor,
  },
  // setup() {},
});

export default Create;
